import { makeAutoObservable } from 'mobx';
import {auth} from 'main/tools';
import axios from 'axios';

class FeatureRequestState {
  modalOpen = false;
  confirmationModalOpen = false;
  body = '';

  constructor() {
    makeAutoObservable(this);
  }

  openModal() {
    this.modalOpen = true;
  }

  closeModal() {
    this.modalOpen = false;
  }

  openConfirmationModal() {
    this.confirmationModalOpen = true;
  }

  closeConfirmationModal() {
    this.confirmationModalOpen = false;
  }

  setBody(value = '') {
    this.body = value;
  }

  submit() {
    axios.post(
      'https://hooks.zapier.com/hooks/catch/2047013/oue3cez/',
      JSON.stringify({
        user_email: auth.user.email,
        user_name: auth.user.firstName + ' ' + auth.user.lastName,
        company_name: auth.company.name,
        body: this.body
      }), {
        transformRequest: [function (data, headers) {
          headers.setContentType(false);

          return data;
        }]
       });

    this.closeModal();
    this.openConfirmationModal();
    this.setBody();
  }
}

export default FeatureRequestState;
